import { render, staticRenderFns } from "./MindMaps.vue?vue&type=template&id=55f761a0&scoped=true"
import script from "./MindMaps.vue?vue&type=script&lang=js"
export * from "./MindMaps.vue?vue&type=script&lang=js"
import style0 from "./MindMaps.vue?vue&type=style&index=0&id=55f761a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../ChatGenial-hom-sync/client/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f761a0",
  null
  
)

export default component.exports